export enum MCarouselControlsType {
  Dots = 'dots',
  Bar = 'bar',
}

export enum MCarouselControlsIconSize {
  S = 'S',
  M = 'M',
  L = 'L',
  XL = 'XL',
  XXL = 'XXL',
  XXXL = 'XXXL',
}

export type MCarouselControlsProps = {
  type?: MCarouselControlsType;
  imageOverlay?: boolean;
  arrows?: boolean;
  icon?: string;
  iconSize?: MCarouselControlsIconSize;
  totalSlides?: number;
  currentSlide?: number;
  onNext?: () => void;
  onPrev?: () => void;
};
